module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAD////////////////////////////////////////////////////////////////////xY8b8AAAAEXRSTlMAvyCf3++vgEAwz5AQX6BwUPldEy8AAADjSURBVFjD7ZhJDsMgDEUT5qkJvv9lW3VTGYJxJKRWld8So2dAbL434QdQA25Jok8wJGWuTDmYoFmqamGKqXPPA1g8ps8DPGyciAwwMYX0nMDG8w+UYnPthC5HeQLqGelyIEQe7exeQaHySYjwV8x0H02IdkDsGtFUHS3is4tIRCISkYhEJCIRiejfRLmGY4Xo/CQCvui42D5soQlRho6MWnDDSBj2ddARNgILLba8w4OBFrNReOhwL1NxdzNkMdBhnLYXq4uiKKiV4ZimGphiw8ZAHawBAkuVqZGGV2uGLML3eQKLzaIXEe5TfgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phone.png
// module id = 5ng9
// module chunks = 1